import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
	openMacroBrowserForInitialConfiguration,
	openMacroBrowserToEditExistingMacro,
} from '../../lib/editor-extensions/index.ts';
import { getExtensionHandlers } from '../../lib/renderer-extensions/index.ts';
import { populateExtensionProviders } from '../Renderer/populateExtensionProviders.ts';
import { loadMacroBrowserResources } from '../../lib/extensions-common/macro-loaders.ts';
import { getMigrationExtensionManifest } from '../../lib/extensions-common/migration-extension/manifest.tsx';

import { ClassicEditorContext } from '@confluence/editor-features/entry-points/ClassicEditorContext.ts';

import Changeboarding from '@confluence-classic/confluence-changeboarding/src/Changeboarding.js';

const extensionUtils = {
	openMacroBrowserForInitialConfiguration,
	openMacroBrowserToEditExistingMacro,
	loadMacroBrowserResources,
	getMigrationExtensionManifest,
	getExtensionHandlers,
	populateExtensionProviders,
	Changeboarding,
};

/**
 * A component to inject extension v1 related functions into the editor extension context.
 * WARN: this component must not be used directly but only via Loadable.
 */
const ClassicEditorContextProvider = ({ children, isWithinEditor = false }) => {
	const ClassicEditorContextValue = useMemo(
		() => ({
			...extensionUtils,
			isWithinEditor,
		}),
		[isWithinEditor],
	);

	return (
		<ClassicEditorContext.Provider value={ClassicEditorContextValue}>
			{children}
		</ClassicEditorContext.Provider>
	);
};

ClassicEditorContextProvider.propTypes = {
	children: PropTypes.node.isRequired,
	isWithinEditor: PropTypes.bool,
};

export default ClassicEditorContextProvider;
